module.exports = __webpack_public_path__ + "static/img/4.79aeb93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/4.png
// module id = x+fG
// module chunks = 1